import { render, staticRenderFns } from "./HMSurveyHeaderButton.vue?vue&type=template&id=96c13df4&scoped=true&"
import script from "./HMSurveyHeaderButton.vue?vue&type=script&lang=js&"
export * from "./HMSurveyHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c13df4",
  null
  
)

export default component.exports